import { configureStore } from '@reduxjs/toolkit'
import { bindStore } from './storeAccess'
import authSlice from './slices/authSlice'
import categorySlice from './slices/categorySlice'
import productSlice from './slices/productSlice'
import cartSlice from './slices/cartSlice'
import homeWidgetSlice from './slices/homeWidgetSlice'
import productTemplateSlice from './slices/productTemplateSlice'
import informationSlice from './slices/informationSlice'
import wishlistSlice from './slices/wishlistSlice'
import orderSlice from './slices/orderSlice'
import brandSlice from './slices/brandSlice'
import manufactureSlice from './slices/manufactureSlice'
import settingSlice from './slices/settingSlice'

const store = configureStore({
  reducer: {
    auth: authSlice,
    category: categorySlice,
    brand: brandSlice,
    manufacture: manufactureSlice,
    product: productSlice,
    cart: cartSlice,
    wishlist: wishlistSlice,
    homeWidget: homeWidgetSlice,
    productTemplate: productTemplateSlice,
    information: informationSlice,
    order: orderSlice,
    setting: settingSlice,
  },
})

bindStore(store)

export default store
